module.exports = __webpack_public_path__ + "img/promo-13seater02.660b5e40.jpg";